// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__3Wz3v","list":"Sidebar_list__2v0m8","tab":"Sidebar_tab__1Fjlj","activeTab":"Sidebar_activeTab__25ael","spinner":"Sidebar_spinner__1YSVi"};